import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';

import { DatadogRumConfig, DatadogRumService } from './datadog-rum.service';

export const DATADOG_RUM_CONFIG = new InjectionToken<DatadogRumConfig | null>('DATADOG_RUM_CONFIG');

/**
 * Provides DatadogRumService. RUM is inited in main.ts; forRoot connects the service (global context,
 * user/account sync). Also provide DatadogRumUserSyncService (from state) in app.module.ts providers.
 */
@NgModule()
export class DatadogRumModule {
  static forRoot(config: DatadogRumConfig | null): ModuleWithProviders<DatadogRumModule> {
    return {
      ngModule: DatadogRumModule,
      providers: [
        { provide: DATADOG_RUM_CONFIG, useValue: config ?? null },
        {
          provide: DatadogRumService,
          useFactory: (c: DatadogRumConfig | null) => {
            const service = new DatadogRumService();
            if (c?.applicationId) {
              service.connect(c);
            }
            return service;
          },
          deps: [DATADOG_RUM_CONFIG],
        },
      ],
    };
  }
}
